import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 23,
			height: 23,
			rx: 4.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 23,
			height: 23,
			rx: 4.5,
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M16.875 12C16.875 11.4844 16.4531 11.0625 15.9375 11.0625H12.9375V8.0625C12.9375 7.54688 12.5156 7.125 12 7.125C11.4609 7.125 11.0625 7.54688 11.0625 8.0625V11.0625H8.0625C7.52344 11.0625 7.125 11.4844 7.125 12C7.125 12.5391 7.52344 12.9375 8.0625 12.9375H11.0625V15.9375C11.0625 16.4766 11.4609 16.875 12 16.875C12.5156 16.875 12.9375 16.4766 12.9375 15.9375V12.9375H15.9375C16.4531 12.9375 16.875 12.5391 16.875 12Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgDropLeft);
export { ForwardRef as ReactComponent };
